import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk'

// Flags can be any JSON serializable type, not just boolean
// Declare all flags here to keep them in one place
// Note: flag names in the LaunchDarkly UI are
// transformed to camelCase in the React SDK
export interface FeatureFlagsSet {
    preReleaseMetrics: boolean
    aiAgentsDevMode: boolean
    aiAgentsPreviewWorkflows: boolean
    marketTrendsStandalonePages: boolean
    keywordResearchV2: boolean
    brandCuration: boolean
    scheduledAgents: boolean
    slackIntegration: boolean
}

// Return a typed set of flags for better typing
// and to centralize dependency on the feature flag library
function useFeatureFlags(): FeatureFlagsSet {
    return useFlags<FeatureFlagsSet>()
}

// The provider defers initialization, so flags read as {} until the client exists. It is
// set once the flags have loaded, or once loading has failed and the flags fall back.
export function useFeatureFlagsReady(): boolean {
    return Boolean(useLDClient())
}

export default useFeatureFlags
